import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3f6fd1', // Azul suave, mesma família do tema escuro
      dark: '#2c4f9e',
      light: '#7b9ce8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00acc1', // Ciano, equivalente claro do secundário escuro
      dark: '#00838f',
      light: '#4dd0e1',
      contrastText: '#ffffff',
    },
    error: {
      main: '#e53935',
      dark: '#c62828',
      light: '#ef5350',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#fb8c00',
      dark: '#ef6c00',
      light: '#ffa726',
      contrastText: '#000000',
    },
    info: {
      main: '#039be5',
      dark: '#0277bd',
      light: '#4fc3f7',
      contrastText: '#000000',
    },
    success: {
      main: '#43a047',
      dark: '#2e7d32',
      light: '#66bb6a',
      contrastText: '#000000',
    },
    background: {
      paper: '#ffffff',
      default: '#f4f6fb',
    },
    text: {
      primary: '#1e293b',
      secondary: '#526079',
      disabled: '#9aa5b1',
    },
    divider: 'rgba(30, 41, 59, 0.12)',
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h2: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h3: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h4: {
      fontWeight: 500,
      color: '#1e293b',
    },
    h5: {
      fontWeight: 500,
      color: '#1e293b',
    },
    h6: {
      fontWeight: 500,
      color: '#1e293b',
    },
    subtitle1: {
      color: '#334155',
    },
    subtitle2: {
      color: '#526079',
    },
    body1: {
      color: '#1e293b',
      lineHeight: 1.5,
    },
    body2: {
      color: '#334155',
      lineHeight: 1.43,
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
    caption: {
      color: '#526079',
    },
    overline: {
      color: '#526079',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1e293b',
          boxShadow: '0 2px 8px rgba(30, 41, 59, 0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 12px rgba(30, 41, 59, 0.1)',
          border: '1px solid rgba(30, 41, 59, 0.06)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#2c4f9e',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(63, 111, 209, 0.3)',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(30, 41, 59, 0.08)',
        },
        head: {
          fontWeight: 600,
          backgroundColor: 'rgba(63, 111, 209, 0.06)',
        },
      },
    },
  },
});

/** @deprecated mantido por compatibilidade — use {@link LightTheme} */
export const PDVThemeBlue = LightTheme;
